require('../shared/sharedBootstrap');
require('../shared/helpers/redirectToLoginOnAxiosAuthError');
require('../shared/components');
require('./components');

import * as VueGoogleMaps from 'vue2-google-maps';
import GmapCluster from 'vue2-google-maps/dist/components/cluster';
import Vuex from 'vuex';

import FormLoader from 'vue-form-loader';

Vue.use(FormLoader);
Vue.use(Vuex);
Vue.use(VueGoogleMaps, {
    load: {
        key: process.env.MIX_GOOGLE_MAPS_KEY,
        libraries: 'drawing,places',
    },
});

if (typeof(Ziggy) !== 'undefined') {
    Vue.mixin({
        methods: {
            route: window.route,
            format_sek: window.format_sek,
            get_request_value: window.get_request_value,
        },
    });
}

const store = require('./stores').default;

Vue.component('gmap-cluster', GmapCluster);
new Vue({
    el: '#app',
    mounted() {
        FormLoader.autoBindToForms();
    },
    store,
});

require('../shared/helpers/utils');
